module.exports = __webpack_public_path__ + "static/media/circle.90a4d727.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/circle.svg
// module id = 272
// module chunks = 0